export const atlanticStyles = {
	header: {
		backgroundColor: '#f3f7f9',
	},
	sidebar: {
		backgroundColor: '#00467f',
		color: 'white',
	},
	button: {
		backgroundColor: '#02a603',
		color: '#FFFFFF',
		border: '1px solid #02a603',
		fontWeight: 600,
		':hover': {
			backgroundColor: '#027d02',
			border: '1px solid #027d02',
		},
	},
	title: {
		color: 'black',
	},
	text: {
		color: '#292f33',
		buttonLoadingColor: '#FFFFFF',
	},
	table: {
		headerBackgroundColor: '#00467f',
		headerTextColor: '#ffffff',
	},
	platformName: {
		name: 'Atlantic Parking Platform',
	},
	logo: {
		small: {
			// Will come from an s3 bucket eventually
			src: '/atlantic/atlantic-icon-background.svg',
			height: 45,
			width: 45,
		},
		large: {
			src: '/atlantic/atlantic-logo-horizontal.png',
			height: 40,
			width: 165,
		},
	},
	favicon: {
		src: '/atlantic/atlantic-icon-background.svg',
	},
	socials: {
		instagram: 'https://www.instagram.com/asgpark',
		x: 'https://www.twitter.com/asgparkdc',
		facebook: 'https://www.facebook.com/ASGPARK/',
		linkedIn: 'https://www.linkedin.com/company/atlantic-services-group-inc.',
	},
	siteUrl: 'https://asgpark.com/',
	orgName: 'Atlantic',
};
